/**import React from "react";
import FrontPicture from "../Assets/front_page.jpg";
import { Container, Row, Col } from 'react-bootstrap';
import "./front.css";
import Image_Pharma from "../Assets/asava_chemist.jpeg";
import Footer from "./footer";

const IntroPage = () => {
    const isMobile = () => window.innerWidth <= 768;

    return (
        <Container fluid style={{ height: '100vh', position: 'relative', marginBottom: "100px" }}>
            <Row className="h-100 no-gutters">
                <Col xs={12} md={6} className="d-flex flex-column justify-content-center" style={{ backgroundColor: 'rgb(250,230,210)', color: 'black', padding: '20px', margin: 0 }}>
                    <h1 style={{ fontSize: '2.5rem', marginBottom: '20px', fontFamily: "serif" }}>ASAVA: Healing Through Excellence</h1>
                    <p style={{ marginBottom: "20px", fontFamily: "serif", fontSize: "20px", textAlign: "justify" }}>
                        At ASAVA, we are dedicated to transforming the landscape of healthcare with 
                        cutting-edge pharmaceutical solutions. Our mission is to enhance the quality 
                        of life for individuals around the globe by developing innovative medications 
                        that address critical health challenges. With a commitment to excellence and 
                        a passion for scientific discovery, ASAVA strives to create safe, effective,
                        and accessible treatments that empower patients and healthcare providers alike.
                        Join us on our journey to redefine health and wellness, as we pave the way for 
                        a healthier future for all.
                    </p>
                </Col>
                <Col xs={12} md={6} className="position-relative" style={{ padding: 0 }}>
                    <img 
                        src={FrontPicture} 
                        style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
                        alt="ASAVA Front Page"
                    />
                </Col>
            </Row>
            <Row className="h-100 no-gutters">
                {!isMobile() && (
                    <Col xs={12} md={6} className="position-relative">
                        <img 
                            src={Image_Pharma} 
                            style={{ width: '100%', height: '100%', objectFit: 'cover', position: 'absolute', top: 0, left: 0 }} 
                            alt="ASAVA Pharmaceutical"
                        />
                    </Col>
                )}
                <Col xs={12} md={isMobile() ? 12 : 6} className="d-flex flex-column justify-content-center" style={{ backgroundColor: 'rgb(176,196,222)', color: 'black', padding: '20px' }}>
                    <h3 style={{ fontFamily: "serif" }}>About ASAVA Pharmaceutical</h3>
                    <h2 style={{ fontFamily: "serif" }}>Commitment to Excellence in Healthcare</h2>
                    <p style={{ fontFamily: "serif", fontSize: "20px", textAlign: "justify" }}>
                        ASAVA Pharmaceutical is a new and ambitious pharmaceutical company based in 
                        Lucknow, poised to make a significant impact across various medical fields. 
                        With a vision to thrive in the pharmaceutical industry, we are dedicated to 
                        expanding our reach throughout the Uttar Pradesh region. Our mission is to 
                        provide high-quality, authentic medicines that address a diverse range of 
                        health conditions. We prioritize honesty and integrity in our operations, 
                        ensuring that every product we offer meets the highest standards of quality. 
                        ASAVA Pharmaceutical is committed to improving patient outcomes by delivering 
                        effective solutions for all healthcare needs.
                    </p>
                </Col>
            </Row>
            <Footer />
        </Container>
    );
};

export default IntroPage;**/

import React from "react";
import { Helmet } from 'react-helmet-async';
import FrontPicture from "../Assets/front_page.jpg";
import { Container, Row, Col } from 'react-bootstrap';
import Image_Pharma from "../Assets/asava_chemist.jpeg";
import Footer from "./footer";
import "./front.css";

const IntroPage = () => {
    return (
        <Container fluid style={{ padding: 0 }}>
            <Helmet>
                <title>Asava Pharmaceutical Pvt Ltd | Top Pharma Company in Lucknow, Basti, UP</title>
                <meta name="description" content="Asava Pharmaceutical Pvt Ltd — top pharma company in Lucknow, Uttar Pradesh. Supplying quality medicines to patients and pharma distributors across Basti, Gorakhpur, Varanasi and all of UP, India." />
                <link rel="canonical" href="https://www.asavapharma.in/" />
                <script type="application/ld+json">{`
                {
                  "@context": "https://schema.org",
                  "@type": "FAQPage",
                  "mainEntity": [
                    {
                      "@type": "Question",
                      "name": "Which is a top pharma company in Lucknow?",
                      "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Asava Pharmaceutical Pvt Ltd is a leading pharma company in Lucknow, Uttar Pradesh, providing quality medicines for bone health, gastro, pain relief, and joint care to patients and distributors."
                      }
                    },
                    {
                      "@type": "Question",
                      "name": "Is there a pharmaceutical company in Basti, UP?",
                      "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Yes, Asava Pharmaceutical Pvt Ltd, based in Lucknow, serves patients and pharma distributors across Basti, Gorakhpur, Varanasi and all districts of Uttar Pradesh, India."
                      }
                    },
                    {
                      "@type": "Question",
                      "name": "How can I become a pharma distributor in Uttar Pradesh?",
                      "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Contact Asava Pharmaceutical Pvt Ltd at +91 92780 77911 or asavapharma@gmail.com to enquire about pharma distribution and wholesale partnerships across Uttar Pradesh."
                      }
                    },
                    {
                      "@type": "Question",
                      "name": "What medicines does Asava Pharmaceutical offer?",
                      "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Asava Pharmaceuticals offers Asavacal XT and Asavacal (bone health), Asvizole and Asvizole DSR (gastrointestinal relief), Asvicoxib-90 and JointFlam pain relief oil (pain relief), Cartivorix (joint health), and Vitnomac CD3 (nerve care)."
                      }
                    },
                    {
                      "@type": "Question",
                      "name": "Does Asava Pharmaceutical supply medicines in bulk for businesses?",
                      "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Yes, Asava Pharmaceutical Pvt Ltd supplies medicines in bulk to pharmacies, hospitals, and distributors across Uttar Pradesh and India. Contact us for B2B pricing and partnership opportunities."
                      }
                    }
                  ]
                }
                `}</script>
            </Helmet>

            
            <Row className="no-gutters" style={{ minHeight: '100vh' }}>
                <Col
                    xs={12} md={6}
                    className="d-flex flex-column justify-content-center"
                    style={{
                        backgroundColor: 'rgb(250,230,210)',
                        padding: '4rem 3rem',
                        position: 'relative',
                        overflow: 'hidden'
                    }}
                >
                    
                    <div style={{
                        position: 'absolute', top: '-60px', right: '-60px',
                        width: '220px', height: '220px', borderRadius: '50%',
                        background: 'rgba(200,140,80,0.12)', pointerEvents: 'none'
                    }} />

                    <h1 style={{
                        fontSize: '2.6rem',
                        fontWeight: 700,
                        fontFamily: 'Georgia, serif',
                        color: '#3b1f0a',
                        lineHeight: 1.2,
                        marginBottom: '1.5rem',
                        position: 'relative'
                    }}>
                        ASAVA: Healing Through Excellence
                        <span style={{
                            display: 'block', width: '60px', height: '3px',
                            background: 'rgb(200,120,50)', marginTop: '14px', borderRadius: '2px'
                        }} />
                    </h1>

                    <p style={{
                        fontFamily: 'Georgia, serif',
                        fontSize: '1rem',
                        lineHeight: 1.85,
                        color: '#5c3a1e',
                        textAlign: 'justify',
                        position: 'relative'
                    }}>
                        At ASAVA, we are dedicated to transforming the landscape of healthcare with
                        cutting-edge pharmaceutical solutions. Our mission is to enhance the quality
                        of life for individuals around the globe by developing innovative medications
                        that address critical health challenges. With a commitment to excellence and
                        a passion for scientific discovery, ASAVA strives to create safe, effective,
                        and accessible treatments that empower patients and healthcare providers alike.
                        Join us on our journey to redefine health and wellness, as we pave the way for
                        a healthier future for all.
                    </p>
                </Col>

                <Col
                    xs={12} md={6}
                    style={{ padding: 0, overflow: 'hidden', position: 'relative' }}
                >
                    <img
                        src={FrontPicture}
                        alt="Asava Pharmaceutical Pvt Ltd - Top Pharma Company in Lucknow Uttar Pradesh India"
                        loading="eager"
                        style={{
                            width: '100%', height: '100%', objectFit: 'cover',
                            display: 'block',
                            transition: 'transform 6s ease'
                        }}
                        onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.04)'}
                        onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
                    />
                    
                    <div style={{
                        position: 'absolute', inset: 0,
                        background: 'linear-gradient(to right, rgba(250,230,210,0.3), transparent)',
                        pointerEvents: 'none'
                    }} />
                </Col>
            </Row>

            
            <Row className="no-gutters" style={{ minHeight: '90vh' }}>
                <Col
                    xs={12} md={6}
                    style={{ padding: 0, overflow: 'hidden', position: 'relative' }}
                    className="d-none d-md-block"
                >
                    <img
                        src={Image_Pharma}
                        alt="Asava Pharmaceutical medicine supplier serving Basti Gorakhpur Varanasi and all districts of Uttar Pradesh"
                        loading="lazy"
                        style={{
                            width: '100%', height: '100%', objectFit: 'cover',
                            display: 'block',
                            transition: 'transform 6s ease'
                        }}
                        onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.04)'}
                        onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
                    />
                </Col>

                <Col
                    xs={12} md={6}
                    className="d-flex flex-column justify-content-center"
                    style={{
                        backgroundColor: 'rgb(176,196,222)',
                        padding: '4rem 3rem',
                        position: 'relative',
                        overflow: 'hidden'
                    }}
                >
                    
                    <div style={{
                        position: 'absolute', bottom: '-80px', right: '-80px',
                        width: '260px', height: '260px', borderRadius: '50%',
                        background: 'rgba(100,140,190,0.2)', pointerEvents: 'none'
                    }} />

                    <h3 style={{
                        fontFamily: 'Georgia, serif',
                        fontSize: '0.85rem',
                        letterSpacing: '0.12em',
                        textTransform: 'uppercase',
                        color: '#2a4a6e',
                        marginBottom: '0.75rem',
                        position: 'relative'
                    }}>
                        About ASAVA Pharmaceutical
                    </h3>

                    <h2 style={{
                        fontFamily: 'Georgia, serif',
                        fontSize: '1.9rem',
                        fontWeight: 700,
                        color: '#0d2a45',
                        lineHeight: 1.25,
                        marginBottom: '0.5rem',
                        position: 'relative'
                    }}>
                        Commitment to Excellence in Healthcare
                        <span style={{
                            display: 'block', width: '50px', height: '3px',
                            background: '#2a6db5', marginTop: '12px', borderRadius: '2px'
                        }} />
                    </h2>

                    <p style={{
                        fontFamily: 'Georgia, serif',
                        fontSize: '1rem',
                        lineHeight: 1.85,
                        color: '#1e3a54',
                        textAlign: 'justify',
                        marginTop: '1rem',
                        position: 'relative'
                    }}>
                        ASAVA Pharmaceutical is a new and ambitious pharmaceutical company based in
                        Lucknow, poised to make a significant impact across various medical fields.
                        With a vision to thrive in the pharmaceutical industry, we are dedicated to
                        expanding our reach throughout the Uttar Pradesh region. Our mission is to
                        provide high-quality, authentic medicines that address a diverse range of
                        health conditions. We prioritize honesty and integrity in our operations,
                        ensuring that every product we offer meets the highest standards of quality.
                        ASAVA Pharmaceutical is committed to improving patient outcomes by delivering
                        effective solutions for all healthcare needs.
                    </p>
                </Col>
            </Row>

            {/* Regions We Serve — keyword-rich section for search rankings */}
            <Row className="no-gutters" style={{ backgroundColor: '#f9f6f1', padding: '4rem 3rem' }}>
                <Col xs={12}>
                    <h2 style={{
                        fontFamily: 'Georgia, serif',
                        fontSize: '1.7rem',
                        fontWeight: 700,
                        color: '#3b1f0a',
                        marginBottom: '1rem',
                        textAlign: 'center'
                    }}>
                        Serving Patients &amp; Pharma Businesses Across Uttar Pradesh
                    </h2>
                    <p style={{
                        fontFamily: 'Georgia, serif',
                        fontSize: '1rem',
                        color: '#5c3a1e',
                        textAlign: 'center',
                        maxWidth: '800px',
                        margin: '0 auto 2rem auto',
                        lineHeight: 1.8
                    }}>
                        Asava Pharmaceutical Pvt Ltd is one of the leading pharma companies in Lucknow, Uttar Pradesh,
                        trusted by patients, pharmacies, hospitals, and distributors across the state.
                        Whether you are looking for a reliable medicine supplier in Lucknow, a pharma distributor in Basti,
                        or a quality pharmaceutical company in UP — Asava Pharmaceuticals delivers across all districts
                        of Uttar Pradesh and beyond.
                    </p>

                    <div style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        justifyContent: 'center',
                        gap: '12px',
                        maxWidth: '900px',
                        margin: '0 auto'
                    }}>
                        {[
                            'Lucknow', 'Basti', 'Gorakhpur', 'Varanasi', 'Kanpur',
                            'Agra', 'Prayagraj', 'Meerut', 'Ayodhya', 'Bareilly',
                            'Ghaziabad', 'Mathura', 'Moradabad', 'Aligarh', 'Sultanpur'
                        ].map(city => (
                            <span key={city} style={{
                                backgroundColor: 'rgb(200,120,50)',
                                color: '#fff',
                                borderRadius: '20px',
                                padding: '6px 18px',
                                fontSize: '0.88rem',
                                fontFamily: 'Georgia, serif',
                                fontWeight: 600
                            }}>
                                {city}
                            </span>
                        ))}
                    </div>

                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        gap: '3rem',
                        marginTop: '3rem',
                        flexWrap: 'wrap'
                    }}>
                        <div style={{ textAlign: 'center' }}>
                            <div style={{ fontSize: '2rem', fontWeight: 700, color: 'rgb(200,120,50)', fontFamily: 'Georgia, serif' }}>75+</div>
                            <div style={{ fontSize: '0.9rem', color: '#5c3a1e', fontFamily: 'Georgia, serif' }}>Districts Served in UP</div>
                        </div>
                        <div style={{ textAlign: 'center' }}>
                            <div style={{ fontSize: '2rem', fontWeight: 700, color: 'rgb(200,120,50)', fontFamily: 'Georgia, serif' }}>6+</div>
                            <div style={{ fontSize: '0.9rem', color: '#5c3a1e', fontFamily: 'Georgia, serif' }}>Pharmaceutical Products</div>
                        </div>
                        <div style={{ textAlign: 'center' }}>
                            <div style={{ fontSize: '2rem', fontWeight: 700, color: 'rgb(200,120,50)', fontFamily: 'Georgia, serif' }}>B2B &amp; B2C</div>
                            <div style={{ fontSize: '0.9rem', color: '#5c3a1e', fontFamily: 'Georgia, serif' }}>Patients &amp; Distributors</div>
                        </div>
                    </div>
                </Col>
            </Row>

            <Footer />
        </Container>
    );
};

export default IntroPage;